import * as angular from 'angular';
import { applicationListStateName } from 'modules/application/list';
import { MicroFrontendService } from 'modules/shared/MicroFrontendService';
import { BlipPaymentsController } from './BlipPaymentsController';
import { BlipPaymentsFeatures } from './BlipPaymentsFeatures';
import BlipPaymentsView from './BlipPaymentsView.html';
import { blipPaymentsScriptSource } from 'app.constants';
export const blipPaymentsStateName = 'auth.blipPayments';
export const blipPaymentsHomeStateName = 'auth.blipPayments.home';
export const blipPaymentsAnalyticsStateName = 'auth.blipPayments.analytics';
export const blipPaymentsAnalyticsListStateName = 'auth.blipPayments.list';
const fetchBlipPaymentsPermission = async ($state, InitializeUserService, AccountService2) => {
    await AccountService2.waitForInitialization();
    await InitializeUserService.initFeatureToggle();
    const isBlipPaymentsEnabled = await BlipPaymentsFeatures.IsBlipPaymentsEnabled();
    if (!isBlipPaymentsEnabled) {
        $state.go(applicationListStateName);
    }
};
const commonStateConfig = {
    controller: BlipPaymentsController,
    controllerAs: '$ctrl',
    template: BlipPaymentsView,
    resolve: {
        authorization: fetchBlipPaymentsPermission,
    },
    onEnter: () => {
        return MicroFrontendService.addSource(blipPaymentsScriptSource);
    },
};
export default angular
    .module('blipPayments', ['ui.router'])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state(blipPaymentsStateName, {
            ...commonStateConfig,
            url: '/blip-payments',
        })
            .state(blipPaymentsAnalyticsStateName, {
            ...commonStateConfig,
            url: '/analytics/overview',
        })
            .state(blipPaymentsAnalyticsListStateName, {
            ...commonStateConfig,
            url: '/analytics/list',
        });
    }]).name;
